import { Component, OnInit, Input } from '@angular/core';
import { ContractOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';

@Component({
  selector: 'app-contract-preview',
  templateUrl: './contract-preview.component.html',
  styleUrls: ['./contract-preview.component.css']
})
export class ContractPreviewComponent implements OnInit {

  _contract: ContractOverviewModel;
  @Input() set contract(contract: ContractOverviewModel){
    this._contract = contract;
    if(contract){
      this.contractPreview = contract.contractnumber + " " + contract.contractdesc;
      if(contract.accessed) this.subTitles.push({ type: "Verwendet", value: moment(contract.accessed).format("DD.MM.YYYY HH:mm:ss") });
      if(contract.customer) this.subTitles.push({ type: "Kunde", value: contract.customer } as SubTitleWrapper);
      if(contract.state) this.subTitles.push({ type: "Status", value: contract.state } as SubTitleWrapper);
      if(contract.type) this.subTitles.push({ type: "Typ", value: contract.type } as SubTitleWrapper);
    }
  }
  get contract(): ContractOverviewModel {
    return this._contract;
  }

  subTitles: SubTitleWrapper[] = [];

  contractPreview: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
